import React from 'react';
import {CouponDiscount} from "./coupon-discount";
import {sliderParams} from "./slider.config";
import Carousel from "react-multi-carousel";
import AppSettings from "settings/app-settings";
import {chileCurrency} from "shared/utils";

import styles from './promotion-banner.module.scss';

const OfferItem = ({item}) => {
    const price = AppSettings.priceReport - AppSettings.priceReport * (item.descuento / 100);

    return (
        <div className={styles.offer}>
            <h4>{item.titulo}</h4>
            <h4 className={styles.offerDescription}>{item.descripcion}</h4>
            <div className={styles.priceContainer}>
                {chileCurrency(price)}
            </div>
            <div className={styles.offerOriginalPrice}> valor normal {AppSettings.priceReport}</div>
        </div>
    )
}

const CouponItem = ({item}) => {
    return (
        <div className={styles.coupon}>
            <CouponDiscount discount={item.descuento}/>
            <h4>{item.titulo}</h4>
            <div className={styles.priceContainer}>
                Código: {item.codigo}
            </div>
        </div>
    )
}

export const PromotionBanner = ({promotions = [], coupons = []}) => {
    const items = [...promotions, ...coupons];

    if(items.length === 0) return <div/>;

    return (
        <Carousel {...sliderParams} className={styles.container}>
            {
                items.map(item => {
                    if (item.tipo === 'cupon')
                        return <CouponItem item={item} key={item.unique_id}/>;
                    return <OfferItem item={item} key={item.unique_id}/>;
                })
            }
        </Carousel>
    );
};
